import {
	IAlarmZoneStatusChangedEvent,
	ILockerGateStatusChangedEvent,
	IMSpaceLockEvent,
} from 'api/interfaces/lockerGate';
import { getConnection } from '../connection';
import { AlertHubMethods } from '../shared/enums';

export const subscribeToLockerGateStatusChanged = (callback: (event: ILockerGateStatusChangedEvent) => void) => {
	const connection = getConnection();
	connection.on(AlertHubMethods.LockerGateStatusChanged, callback);
};

export const subscribeToAlarmZoneStatusChanged = (callback: (event: IAlarmZoneStatusChangedEvent) => void) => {
	const connection = getConnection();
	connection.on(AlertHubMethods.AlarmZoneStatusChanged, callback);
};

export const subscribeToMSpaceLockResult = (
	onOpened: (event: IMSpaceLockEvent) => void,
	onNotOpened: (event: IMSpaceLockEvent) => void
) => {
	const connection = getConnection();
	connection.on(AlertHubMethods.MSpaceLockOpened, onOpened);
	connection.on(AlertHubMethods.MSpaceLockNotOpened, onNotOpened);
};
